import { soundTick } from "@/sounds/ui";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  hideLabel?: boolean;
  disabled?: boolean;
}

export function Toggle({ checked, onChange, label, hideLabel, disabled }: ToggleProps) {
  const flip = () => {
    if (disabled) return;
    soundTick();
    onChange(!checked);
  };
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={hideLabel ? label : undefined}
      className="bd-toggle"
      onClick={flip}
      disabled={disabled}
    >
      <span className="bd-toggle__track">
        <span className="bd-toggle__thumb" />
      </span>
      {!hideLabel && <span className="bd-toggle__label">{label}</span>}
    </button>
  );
}
